import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class ProductsDirectorySubCategory extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    link: PropTypes.string,
    ghost: PropTypes.bool,
    color: PropTypes.string,
  };

  render() {
    const { name, link, ghost, color } = this.props;

    const styles = {
      ghost: classnames('products-directory--subcat-grid--subcat-ghost'),
      wrapper: classnames({
        'products-directory--subcat-grid--subcat': true,
        'products-directory--subcat-grid--subcat--low-volt': color === 'low-volt',
        'products-directory--subcat-grid--subcat--mid-volt': color === 'mid-volt',
        'products-directory--subcat-grid--subcat--high-volt': color === 'high-volt',
        'products-directory--subcat-grid--subcat--printed': color === 'printed',
        'products-directory--subcat-grid--subcat--tape': color === 'tape',
      }),
      content: classnames('products-directory--subcat-grid--subcat--content'),
      centeredContent: classnames('products-directory--subcat-grid--subcat--centered-content'),
      icon: classnames('fa', 'fa-link'),
      name: classnames('products-directory--subcat-grid--subcat--name'),
    };

    // ghost items to keep same width of the others
    if (ghost) {
      return (
        <li className={styles.ghost} />
      );
    }

    return (
      <li className={styles.wrapper}>
        <a className={styles.content} target="_blank" href={link}>
          <div className={styles.centeredContent}>
            <i className={styles.icon}></i>
            <div className={styles.name}>{name}</div>
          </div>
        </a>
      </li>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/ProductsDirectorySubCategory.jsx
 **/